module.exports = __webpack_public_path__ + "img/bigstock-Businessmen-and-businesswomen--267296758.80904db8.jpg";